import Image from "next/image";

import { useDispatch } from "react-redux";

import { MealCard } from "@chef/components";
import { RecipesByIngredientCategoriesQuery } from "@chef/state-management";
import { findFeaturedPortraitImage } from "@chef/state-management/helpers";
import { BASE_64_1X1_GREY, BRAND_PATHS, language } from "@chef/constants";
import { RecipeReactionButton, RecipeTags } from "@chef/smart-components";
import { openModal } from "@chef/state-management";
import { slugify } from "@chef/helpers";

interface RecipeListProps {
  recipes?: RecipesByIngredientCategoriesQuery["getRecipesByIngredientCategories"]["recipes"];
}

export const RecipeList = ({ recipes }: RecipeListProps) => {
  const dispatch = useDispatch();

  if (!recipes) {
    return null;
  }

  return (
    <div
      className="grid grid-cols-2 gap-2 mt-4 lg:gap-4 md:grid-cols-3 xl:grid-cols-5"
      id="cards-grid"
    >
      {recipes.map((recipe, index) => {
        const url = findFeaturedPortraitImage(recipe)?.url;

        const modalRoute = BRAND_PATHS.RECIPE_WITH_NAME_HREF({
          recipeId: recipe.recipeId,
          recipeName: slugify(recipe.recipeName),
        });

        return (
          <div className="relative" key={recipe.recipeId}>
            <MealCard
              key={recipe.recipeId}
              className="h-full"
              language={language}
              text={recipe.recipeName}
              tags={<RecipeTags recipe={recipe} />}
              href={modalRoute}
              id={recipe.recipeId.toString()}
              Image={() => (
                <Image
                  src={url || BASE_64_1X1_GREY}
                  width={2}
                  height={3}
                  alt={recipe.recipeName}
                  className="object-cover w-full h-auto rounded-t aspect-2/3"
                  sizes="(max-width: 375px) 50w, (max-width: 768px) 35vw, 20vw"
                  priority={index < 5} // First few images was detected as the Largest Contentful Paint (LCP). Need to add the "priority" property if image is above the fold.
                />
              )}
              hideFooter
              onClick={(e) => {
                e.preventDefault();
                dispatch(
                  openModal({
                    id: "RECIPE",
                    recipeId: recipe.recipeId,
                    view: "conversion",
                  }),
                );
              }}
            />
            <RecipeReactionButton
              recipe={recipe}
              className="absolute z-10 shadow top-4 right-4"
            />
          </div>
        );
      })}
    </div>
  );
};
